
import React, { useEffect, useState } from "react";
import API from "../Services/SalesTab";
import moment from "moment";
import LocationList from "../Components/Location";
import PriceTypeList from "../Components/PriceType";
import ButtonColorList from "../Components/ButtonColor";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DisplayOrder from "../Components/DisplayOrder";
import APISS from '../Services/Location';

const SalesTabList = () => {
  const [salesTab, setSalesTab] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const perPage = 10;
  const [tabName, setTabName] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  const [displayOrder, setDisplayOrder] = useState("");
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [priceTypeId, setPriceTypeId] = useState("");
  const [priceTypeName, setPriceTypeName] = useState("");
  const [buttonColorName, setButtonColorName] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});
  const [displayOrder1, setDisplayOrder1] = useState("")
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [location, setLocation] = useState([])


  useEffect(() => {
    bindSalesTab();
    bindLocation();
  }, [currentPage]);

  const bindLocation = async () => {
    try {
      const response = await APISS.getLocationList({
        is_active: 1,
        limit: 0,
       
      });
      setLocation(response?.data?.data || []);
      // setLocation1(response?.data?.data || [])
    } catch (error) {
      //setError("Failed to fetch locations.");
      console.error(error);
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
    }
  };

  const bindSalesTab = async () => {
    try {
      const payload = {
        limit: perPage,
        pageNumber: currentPage,
        is_active: selectedStatus,
         location_ids:parseInt(selectedLocation) || null,
      };
      const data = await API.Sales_Tab_List(payload);
      const details = data?.data?.data;
      // console.log("detail data.dd.", data.data?.totalCount)
      setTotalRecords(data.data?.totalCount);
      setSalesTab(details);
    } catch (error) {
      toast.dismiss();
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
        toast.error("Network error! Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };


  const totalPages = Math.ceil(totalRecords / perPage);
  // console.log('totalPages', totalPages);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);
      if (left > 2) {
        pageNumbers.push(1, '...');
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push('...', totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };
  const handleStatusToggle = async (id, currentStatus) => {
    try {
      const updatedStatus = !currentStatus;
      const response = await API.UpdateStatus(id);
      // console.log('response.status', response.status);
      if (response.status === 200) {
        setSalesTab((prevTabs) =>
          prevTabs.map((item) =>
            item.id === id ? { ...item, is_active: updatedStatus } : item
          )
        );
        toast.success(response.data.message);
        //  setTimeout(() => window.location.reload(), 2000);
        bindSalesTab();
      } else {
        toast.error("Failed to update the status.");
      }
    } catch (error) {
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
      toast.error("Error updating status. Please try again.");
      console.error("Error toggling status:", error);
    }
  };

  const handleGetData = async (id) => {
    try {
      const payload = {
        id: id,
        limit: 1,
        pageNumber: 1
      }
      const response = await API.Sales_Tab_List(payload);
      const fetchedData = response?.data?.data?.[0];
      // response?.data?.data?.rows?.[0]
      // console.log('fetchedData', fetchedData.display_order);
      if (fetchedData) {
        setEditId(fetchedData.id);
        setTabName(fetchedData.tab_name);
        setButtonColor(fetchedData.button_color_id);
        setDisplayOrder(fetchedData.display_order);
        setLocationId(fetchedData.location_id);
        setPriceTypeId(fetchedData.price_type_id);
        setCreatedAt(fetchedData.createdAt);
        setPriceTypeName(fetchedData.price_type);
        setButtonColorName(fetchedData.button_color);
        // , setCreatedAt
        //locationName, 
        setLocationName(fetchedData.location_name);
        setDisplayOrder1(fetchedData.display_order)
      } else {
        toast.error("Failed to fetch sales tab details.");
      }
    } catch (error) {
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
      toast.error("Error fetching data.");
      console.error("Error fetching sales tab details:", error);
    }
  };

  const handleUpdate = async () => {
   
    if (!tabName) {
      toast.error("Please Enter a TabName.");
      return;
    }
    // if (!buttonColor) {
    //   toast.error("Please select a Button Color.");
    //   return;
    // }
    // if (displayOrder === "Select" || displayOrder === "") {
    //   toast.error("Please select a Display Order.");
    //   return;
    // }
    // if (!locationId) {
    //   toast.error("Please select a location.");
    //   return;
    // }

    if (!priceTypeId) {
      toast.error("Please select a Price Type.");
      return;
    }

    try {
      const payload = {
        id: editId,
        tab_name: tabName,
        button_color: parseInt(buttonColor) || parseInt(1),
        display_order: displayOrder || displayOrder1 || 0,
        location_id: parseInt(locationId),
        price_type_id: priceTypeId,
      };
     // console.log("update payload...", payload)
      const response = await API.updateSalesTab(editId, payload);
      // console.log("response data....", response?.data)
      if (response.status === 200) {
        toast.success(response.data.message);
        bindSalesTab();
        setTimeout(() => window.location.reload(), 2000);
        //setEditId(null);
      } else {
        toast.error("Failed to update sales tab.");
      }
    } catch (error) {
      console.log('error.response', error.response.status)
      if (error.response) {

        const errorMsg = error.response.data.errors?.[0]?.msg || error.response.data.message || "An error occurred.";
        toast.error(`Error: ${errorMsg}`);
      }
      else if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };
  const handleSearchData = async () => {
    setCurrentPage(1);
    bindSalesTab(1);
  }
  return (
    <div>

      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Added Sales Tabs</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="ddSalesType" className="form-label">
                    <b>Center</b>
                  </label>
                  <select
                    className="form-select"
                    id="ddSalesType"
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                  >
                    <option value="">Select</option>
                    {location.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="ddSalesType" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select"
                    id="ddSalesType"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}>
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <label></label>
                <button onClick={handleSearchData} className="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Action</th>
                    <th>Tab Name</th>
                    <th>Center</th>
                    {/* <th>Display Order</th> */}
                    <th>Price Type</th>
                    {/* <th>Button Color</th> */}
                    <th>Status</th>
                    <th>Created-Date</th>
                  </tr>
                </thead>
                <tbody>
                  {salesTab.map((item, index) => (
                    // <tr key={item.id}>

                    <tr
                      key={item.id}
                      data-active={item?.is_active ? "true" : "false"}
                    >
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>
                        <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                          <ul className="navbar-nav navbar-nav-right">
                            <li className="nav-item nav-profile1">
                              <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                <div className="nav-profile-text1">
                                  <p className="mb-1 text-black">
                                  </p>
                                </div>
                              </span>
                              <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                              <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                <a className="dropdown-item">
                                  <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewSalesTab">
                                    View
                                  </button>
                                </a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item">
                                  <button onClick={() => handleGetData(item.id)}
                                    className="btn btn-primary btn-sm" type="button"
                                    data-bs-toggle="modal" data-bs-target="#myModal"
                                  >
                                    Edit
                                  </button>
                                </a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item">
                                  <button
                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                    onClick={() => handleStatusToggle(item.id, item.is_active)}
                                  >
                                    {item.is_active ? "De-Activate" : "Activate"}
                                  </button>
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </td>

                      {/* <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleGetData(item.id)}
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                        >
                          Edit
                        </button>{" "}
                        <button
                          className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                          onClick={() => handleStatusToggle(item.id, item.is_active)}
                        >
                          {item.is_active ? "Deactivate" : "Activate"}
                        </button> */}
                      <td>{item.tab_name}</td>
                      <td>{item.location_name}</td>
                      {/* <td>{item.display_order}</td> */}
                      <td>{item.price_type}</td>
                      {/* <td>{item.button_color}</td> */}
                      <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                      <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <nav aria-label="Page navigation">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                      Previous
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      )}
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className="modal" id="myModal" data-bs-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Sales Tab</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <label>Tab Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" value={tabName} onChange={(e) => setTabName(e.target.value)} />
                  </div>
                  {/* <div className="col-md-6">
                    <ButtonColorList
                      selectedButtonColor={buttonColor}
                      setSelectedButtonColor={setButtonColor}
                      buttonColors={buttonColor}
                    />
                  </div> */}
                </div>
                <div className="row my-3">
                  <div className="col-md-6">
                    {/* <DisplayOrder
                      selectedDisplayOrder={displayOrder}
                      setSelectedDisplayOrder={setDisplayOrder}
                      // setSelectedDisplayOrder={(val) => {
                      //   setDisplayOrder(val);
                      //   if (val.trim()) {
                      //     setErrors((prev) => {
                      //       const updated = { ...prev };
                      //       delete updated.displayOrder;
                      //       return updated;
                      //     });
                      //   }
                      // }}
                    /> */}

                    {/* <DisplayOrder
                      selectedDisplayOrder={displayOrder}
                      setSelectedDisplayOrder={(val) => {
                        setDisplayOrder(val);
                        if (val && val !== "Select") {
                          setErrors((prev) => {
                            const updated = { ...prev };
                            delete updated.displayOrder;
                            return updated;
                          });
                        }
                      }}
                    /> */}

                  </div>
                  <div className="col-md-12">
                    <PriceTypeList selectedPriceType={priceTypeId} setSelectedPriceType={setPriceTypeId} />

                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleUpdate}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="modal" id="myModalViewSalesTab">
          <div className="modal-dialog  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Sales Tab Details</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered border-secondary">
                  <thead>
                    <tr>
                      <th>Tab Name</th>
                      <th>Location</th>
                      {/* <th>Display Order</th> */}
                    </tr>
                    <tr>
                      <td>
                        {tabName}
                      </td>
                      <td>
                        {locationName}
                      </td>
                      {/* <td>
                        {displayOrder}
                      </td> */}
                    </tr>
                    <tr>
                      <th>Price Type</th>
                      {/* <th>Button Color</th> */}
                      <th>Created-Date</th>
                    </tr>
                    <tr>
                      <td>{priceTypeName}</td>
                      {/* <td>{buttonColorName}</td> */}
                      <td>{moment(createdAt).format("DD-MM-YYYY")}</td>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className="modal-footer">
                {/* <button type="button" class="btn btn-info" data-bs-dismiss="modal">Close</button> */}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default SalesTabList;
